<script lang="ts">
	interface Props {
		size?: number;
		strokeWidth?: number;
		class?: string;
	}

	let { size = 24, strokeWidth = 2.5, class: className = '' }: Props = $props();

	// Периметр окружности — из него считаются штрихи дуги.
	const RADIUS = 10;
	const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
</script>

<svg
	class="spinner {className}"
	width={size}
	height={size}
	viewBox="0 0 24 24"
	role="status"
	aria-label="Загрузка"
>
	<circle
		cx="12"
		cy="12"
		r={RADIUS}
		fill="none"
		stroke="currentColor"
		stroke-width={strokeWidth}
		stroke-linecap="round"
		stroke-dasharray="{CIRCUMFERENCE * 0.25} {CIRCUMFERENCE * 0.75}"
	/>
</svg>

<style>
	.spinner {
		display: block;
		flex-shrink: 0;
		animation: rotate 0.8s linear infinite;
	}

	@keyframes rotate {
		to {
			transform: rotate(360deg);
		}
	}

	/* При включённой системной настройке «уменьшить движение» вращение
	   заменяется пульсацией: индикатор остаётся заметным, но не крутится. */
	@media (prefers-reduced-motion: reduce) {
		.spinner {
			animation: pulse 1.4s ease-in-out infinite;
		}

		@keyframes pulse {
			0%,
			100% {
				opacity: 1;
			}
			50% {
				opacity: 0.35;
			}
		}
	}
</style>
